module.exports = __webpack_public_path__ + "img/tft-active.027cd5aa.png";